module.exports = __webpack_public_path__ + "static/img/top.4db0bfc2.png";